import { ImageFile, PictureStepActionPayload } from '../../../state';
import { imageMatcherAI } from './imageMatcherAI';
import { updatePerfectlyMatchedImages } from './updatePerfectlyMatchedImages';

export function collateImages(
	images: ImageFile[],
	newImages: PictureStepActionPayload['END_HUBSPOT_FILE_UPLOAD'],
): ImageFile[] {
	const [matchedImages, unmatchedImages, unmatchedResponses] =
		updatePerfectlyMatchedImages(images, newImages);

	const probablyMatchedImages = imageMatcherAI(
		unmatchedImages,
		unmatchedResponses,
	);

	// Anything now not matched, we can assume was devine intervention.
	const updatedState: ImageFile[] = [
		// Put back all the other images not in this batch
		...images.filter(
			(image) => image.uploadBatchId !== newImages.uploadBatchId,
		),
		// Add the matched images
		...matchedImages,
		...probablyMatchedImages,
	];
	return updatedState;
}
